var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopygray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8673 0H4.76341C4.36002 0 4.03263 0.334328 4.03263 0.746269V4.02637H0.820621C0.417232 4.02637 0.0898438 4.3607 0.0898438 4.77264V19.2537C0.0898438 19.6657 0.417232 20 0.820621 20H11.9245C12.3279 20 12.6553 19.6657 12.6553 19.2537V15.9736H15.8673C16.2707 15.9736 16.5981 15.6393 16.5981 15.2274V0.746269C16.5981 0.334328 16.2707 0 15.8673 0ZM11.1938 18.5075H1.5514V5.51891H11.1938V18.5075ZM15.1366 14.4811H12.6553V4.77264C12.6553 4.3607 12.3279 4.02637 11.9245 4.02637H5.49419V1.49254H15.1366V14.4811Z",
    fill: "#B0B7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopygray);
export default __webpack_public_path__ + "static/media/copygray.202dba0484e6f8bfd207ab5c16d6f1b9.svg";
export { ForwardRef as ReactComponent };